module.exports = __webpack_public_path__ + "static/img/1486_phase_function_Paper_Points.16518aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1486_phase_function_Paper_Points.png
// module id = vhCv
// module chunks = 0